import { useCallback, useLayoutEffect, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

export function useTruncated(ref: any) {
  const [isTruncated, setTruncated] = useState<boolean>(false);

  const handleResize = useCallback((entries: ResizeObserverEntry[]) => {
    if (Array.isArray(entries)) {
      const {
        target: { scrollWidth, clientWidth }
      } = entries[0];
      setTruncated(scrollWidth > clientWidth);
    }
  }, []);

  useLayoutEffect(() => {
    if (ref?.current) {
      const RO = new ResizeObserver(handleResize);
      RO.observe(ref.current);

      return () => {
        RO.disconnect();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref]);
  return { isTruncated };
}
